import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import setMetaTags from "../../../common/helpers/metaSetter";
import ResultsChooser from "../../../ResultsChooser";
import LoginModal from "../../../components/LoginModal";
import VariantInfoIcons from "./VariantInfoIcons";
import VariantInfoClassifications from "./VariantInfoClassifications";
import MitochondrialMessage from "./MitochondrialMessage";

function VariantInfo({
  queryType,
  genome,
  variantResult,
  userQuery,
  multipleResults,
}) {
  const [showLoginModal, setShowLoginModal] = useState(false);

  useEffect(() => {
    if (variantResult) {
      setMetaTags(queryType, genome.name, userQuery, variantResult);
    }
  }, [queryType, genome, userQuery, variantResult]);

  return (
    <div id="variant-info" className="backdrop-filter-blur tw-bg-opacity-80">
      {variantResult ? (
        <div className="tw-flex tw-flex-wrap tw-items-end tw-px-10 tw-py-2 tw-mx-auto tw-max-w-1800">
          <div className="tw-flex-1">
            {Array.isArray(multipleResults) && multipleResults.length > 1 && (
              <div className="tw-text-white tw-mb-1">
                {queryType === "aminoacid"
                  ? "Your query results in several genomic alleles which all give the protein sequence variant you specified, click on each to see its data"
                  : "Your query results in several genomic alleles, click on each to see its data"}
              </div>
            )}
            <ResultsChooser
              multipleResults={multipleResults}
              selectedResult={variantResult}
              queryType={queryType}
            />
            <MitochondrialMessage />
            <VariantInfoClassifications />
          </div>
          <div className="tw-ml-auto" style={{ flex: "0 0 auto" }}>
            <VariantInfoIcons />
          </div>
        </div>
      ) : null}
      <LoginModal
        showModal={showLoginModal}
        toggleModal={() => setShowLoginModal(!showLoginModal)}
      />
    </div>
  );
}

VariantInfo.propTypes = {
  variantResult: PropTypes.shape({}),
  userQuery: PropTypes.string,
  queryType: PropTypes.string,
  genome: PropTypes.shape({ name: PropTypes.string, id: PropTypes.number }),
  // eslint-disable-next-line react/forbid-prop-types
  multipleResults: PropTypes.arrayOf(PropTypes.any),
  variantQueryMode: PropTypes.shape({}),
};

VariantInfo.defaultProps = {
  userQuery: "",
  queryType: "",
  variantResult: null,
  genome: {},
  multipleResults: [],
  variantQueryMode: null,
};

const mapStateToProps = (state) => ({
  userQuery: state.userQuery,
  queryType: state.queryType,
  variantResult: state.variantResult,
  multipleResults: state.multipleResults,
  genome: state.genome,
  varsomeHost: state.varsomeHost,
  variantQueryMode: state.variantQueryMode,
  isIntermediate: state.isIntermediate,
  hasNext: state.hasNext,
});

export default connect(mapStateToProps)(VariantInfo);
